import type { TFunction } from "i18next";
import { z } from "zod";

export const createReportSchema = (t: TFunction) => {
  return z.object({
    reason: z
      .number({ invalid_type_error: t("common.reportReasonRequired") })
      .min(1, t("common.reportReasonRequired")),
    details: z.string().optional(),
  });
};

export type ReportSchema = ReturnType<typeof createReportSchema>;
export type ReportFormValues = z.infer<ReportSchema>;
